export default function SvgPlay2() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      viewBox="-3 0 28 28"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g fill="#fff" transform="translate(-419 -571)">
          <path d="M440.415 583.554l-18.997-12.243c-1.127-.607-2.418-.544-2.418 1.635v24.108c0 1.992 1.385 2.306 2.418 1.635l18.997-12.243a2.076 2.076 0 000-2.892"></path>
        </g>
      </g>
    </svg>
    </>
    );
  }
                          